import React, { useEffect, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // default styling
import { getCampaignUpdateAction, getProfileVisitAction, getSingleCampaignDetailAction } from '../../actions/peopleai';
import { Route, useNavigate, useParams } from 'react-router';
import { RoutesPaths } from '../../Router/constant';
import { backendUrl, privacy, terms, websiteUrl } from '../../constants';
import { logoutInvalidToken } from '../../actions/auth';
import { useSearchParams } from 'react-router-dom';
import PublicPageHeader from '../../components/PublicPageHeader';
import CampaignCarousel from './CampaignCarousel';
import CampaignUpdates from './CampaignUpdates';
import PublicPageFooter from '../../components/PublicPageFooter';
import CampaignPreviewSkeleton from './CampaignPreviewSkeleton';
import AdvisorProfile from '../../components/AdvisorProfile';
import AboutAdvisor from '../../components/AboutAdvisor';
import VerificationIcons from '../../components/VerificationIcons';
import OtherCampaignsAdvisor from '../../components/OtherCampaignsAdvisor';
import OtherQuotationAdvisor from '../../components/OtherQuotationAdvisor';

const PeopleAi = () => {
    const currentYear = new Date().getFullYear();
    const { id, tracking } = useParams()
    const { singleCampaignDetail, campaignUpdateList, campaignUpdateTotal, singleCampaignDetailLoader } = useSelector(state => state.peopleai);

    const { isLoggedIn } = useSelector(state => state?.auth);

    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImages, setPreviewImages] = useState([]);
    const [previewIndex, setPreviewIndex] = useState(0);
    const [updatePage, setUpdatePage] = useState(1);

    const isloadingRef = useRef(false)
    const { campaign } = singleCampaignDetail
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const loadRef = useRef(true);

    const [queryParameters] = useSearchParams();
    const isAdvisorUser = campaign?.company?.isDefault

    useEffect(() => {
        const root = document.documentElement;

        if (isAdvisorUser) {
            root.style.setProperty("--primary-color", "#494DA2");
            root.style.setProperty("--third-color", "rgba(73, 77, 162, 0.4)");
            root.style.setProperty("--linear-primary", "linear-gradient(90deg, #0d1b26 0%, #494DA2 100%)");
            root.style.setProperty("--low-opacity-primary", "rgba(73, 77, 162, 0.05)");
            root.style.setProperty('--step-card-background', 'rgba(73, 77, 162, 0.10)');
            root.style.setProperty('--linear-overlay', "linear-gradient(to bottom, rgba(0, 0, 0, 0.05), #484ca0)");
        } else {
            root.style.setProperty("--primary-color", "#2978b5");
            root.style.setProperty("--third-color", "#91bdde");
            root.style.setProperty("--linear-primary:", "linear-gradient(90deg, #0d1b26 0%, #30638c 100%)");
            root.style.setProperty("--low-opacity-primary", "rgba(41, 120, 181, 0.05)");
            root.style.setProperty('--step-card-background', 'rgba(41, 120, 181, 0.05)');
            root.style.setProperty('--linear-overlay', "linear-gradient(to bottom, rgba(0, 0, 0, 0.05), #30638c)");
        }
    }, [isAdvisorUser]);

    useEffect(() => {
        const trackingId = tracking;
        if (loadRef.current) {
            const takeAction = async () => {
                if (trackingId) {
                    localStorage.setItem("trackingId", trackingId);
                }
            };
            takeAction().catch(console.error);
        }

        return () => {
            loadRef.current = false;
        };
    }, [queryParameters, dispatch]);


    useEffect(() => {
        if (!isloadingRef?.current) {
            if (isLoggedIn) {
                dispatch(logoutInvalidToken())
                isloadingRef.current = true
            }
        }
        const getcampaign = async () => {
            var resp = await dispatch(getSingleCampaignDetailAction(id))
            // localStorage.removeItem("token");
            dispatch(getProfileVisitAction(id))
            if (!resp?.status) {
                navigate(RoutesPaths.ERROR_PAGE, { replace: true });
            }
        }
        getcampaign()
    }, [dispatch, id])

    useEffect(() => {
        if (id) {
            dispatch(getCampaignUpdateAction(updatePage, 5, id));
        }
    }, [id, updatePage])




    const sendMessage = () => {
        localStorage.removeItem("token")
        navigate(RoutesPaths.MESSAGE_DETAIL_PUBLIC_CHAT_CAMPAIGN.replace(":id", campaign?.creator?._id).replace(":campaignId", id));
    }

    const imagePath = campaign?.company?.isDefault
        ? campaign?.creator?.profilePic?.filename
        : campaign?.company?.logo;

    const imageUrl = imagePath ? `${backendUrl}${imagePath}` : null;
    const linkedinUrl =
        campaign?.creator?.linkedinUrl?.trim() || campaign?.company?.linkedInUrl?.trim();

    const placeholder = "/assets/img/Frame1.svg";

    const AboutCompany = () => {
        return (
            <div className="qpOrganizerBox OrganizerCampaign">
                <h5 className="qpOrganizerTitle">Organizer</h5>
                <div className="qpOrganizerRow">

                    <div className="qpOrganizerProfile">
                        <img
                            className="qpOrganizerAvatar"
                            src={imageUrl || placeholder}
                            alt="profile"
                            onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = placeholder;
                            }}
                        />

                        <div>

                            <div className="qpOrganizerName">
                                {campaign?.company?.isAdvisor ? campaign?.creator?.first_name + " " + campaign?.creator?.last_name : campaign?.company?.companyName}
                            </div>
                            {isAdvisorUser ? <p className="qpOrganizerRole">Partner</p> :
                                <p lassName="qpOrganizerRole">
                                    {campaign?.company?.companyRoleUser?.join(", ") || "Promoter"}
                                </p>}
                        </div>

                    </div>

                    <p onClick={() => navigate(RoutesPaths.SHARE_PAGE.replace(":id", campaign?.company?._id))}
                        className="qpViewProfileLink">
                        View profile
                    </p>

                </div>

            </div>
        );
    };


    function getTimeAgo(createdAt) {
        const now = Date.now();
        const then = new Date(createdAt).getTime();
        const diff = now - then; // milliseconds

        const units = [
            { name: "year", ms: 1000 * 60 * 60 * 24 * 365 },
            { name: "month", ms: 1000 * 60 * 60 * 24 * 30 },
            { name: "week", ms: 1000 * 60 * 60 * 24 * 7 },
            { name: "day", ms: 1000 * 60 * 60 * 24 },
            { name: "hour", ms: 1000 * 60 * 60 },
            { name: "minute", ms: 1000 * 60 },
            { name: "second", ms: 1000 },
        ];

        for (let { name, ms } of units) {
            const val = Math.floor(diff / ms);
            if (val > 0) {
                return `${val} ${name}${val > 1 ? "s" : ""} ago`;
            }
        }
        return "just now";
    }


    const seeMore = () => {
        if (campaignUpdateTotal > (campaignUpdateList?.length || 0)) {
            setUpdatePage(prev => prev + 1);
        }
    };

    const status = campaign?.status;

    const getStatusClass = () => {
        switch (status) {
            case "launched":
                return {
                    container: "campaignStatusSection activeCampaign",
                    dot: "dot activeDot",
                    text: "Active",
                };
            case "inprogress":
            case "pause":
                return {
                    container: "campaignStatusSection PendingCampaign",
                    dot: "dot PendingDot",
                    text: "Paused",
                };
            case "cancel":
                return {
                    container: "campaignStatusSection FailedCampaign",
                    dot: "dot FailedDot",
                    text: "Cancelled",
                };
            default:
                return {
                    container: "campaignStatusSection PendingCampaign",
                    dot: "dot PendingDot",
                    text: "Paused",
                };
        }
    };

    const statusClass = getStatusClass();
    const isInactiveCampaign =
        singleCampaignDetail?.campaign?.status === 'pause' ||
        singleCampaignDetail?.campaign?.status === 'cancel';

    return (
        <>
            <PublicPageHeader />
            {singleCampaignDetailLoader ?
                <CampaignPreviewSkeleton />
                :
                <>
                    <div className={`container campaignPageScreen ${isInactiveCampaign ? 'campaignPageScreenCompact' : ''}`}>
                        {isInactiveCampaign &&
                            <div className={`successToastHolder mb-2`}>
                                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M10.1667 2.66667C6.02453 2.66667 2.66667 6.02453 2.66667 10.1667C2.66667 14.3088 6.02453 17.6667 10.1667 17.6667C14.3088 17.6667 17.6667 14.3088 17.6667 10.1667C17.6667 6.02453 14.3088 2.66667 10.1667 2.66667ZM1 10.1667C1 5.10406 5.10406 1 10.1667 1C15.2293 1 19.3333 5.10406 19.3333 10.1667C19.3333 15.2293 15.2293 19.3333 10.1667 19.3333C5.10406 19.3333 1 15.2293 1 10.1667Z" fill={isAdvisorUser ? "#494DA2" : "#2978b5"} />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M10.1675 9.31934C10.6354 9.31934 11.0148 9.69865 11.0148 10.1666V13.5554C11.0148 14.0234 10.6354 14.4027 10.1675 14.4027C9.69963 14.4027 9.32031 14.0234 9.32031 13.5554V10.1666C9.32031 9.69865 9.69963 9.31934 10.1675 9.31934Z" fill={isAdvisorUser ? "#494DA2" : "#2978b5"} />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M9.32031 6.77789C9.32031 6.30998 9.69963 5.93066 10.1675 5.93066H10.176C10.6439 5.93066 11.0232 6.30998 11.0232 6.77789C11.0232 7.24579 10.6439 7.62511 10.176 7.62511H10.1675C9.69963 7.62511 9.32031 7.24579 9.32031 6.77789Z" fill={isAdvisorUser ? "#494DA2" : "#2978b5"} />
                                </svg>

                                <div className="contentHolder">
                                    <p className="header">
                                        {`Currently this campaign was ${singleCampaignDetail?.campaign?.status === 'cancel'
                                            ? 'cancelled'
                                            : 'paused'
                                            } by ${campaign?.creator?.first_name + " " + campaign?.creator?.last_name }`
                                        }
                                    </p>
                                </div>
                            </div>
                        }
                        <div className='row'>
                            <div className='col-md-8'>
                                <CampaignCarousel images={singleCampaignDetail?.campaign?.images} />
                                <div className='posterTitleSection'>
                                    <h2 className="title">{campaign?.name}</h2>
                                    <div className='campaignStatusSectionOut'>
                                        <div className={statusClass.container}>
                                            <div className={statusClass.dot}></div>
                                            <p className="m-0">{statusClass.text}</p>
                                        </div>
                                        <p className="posted-time m-0">Posted {getTimeAgo(campaign?.createdAt)}</p>
                                    </div>
                                </div>
                                {/* <div
                            className="campaign-image"
                            style={{ backgroundImage: `url(${campaign?.company?.banner ? backendUrl + campaign?.company?.banner : "/assets/img/peopleAi.png"})` }}></div> */}
                                <div className="about-section">
                                    <div className='outerSectionCampaign'>
                                        <h6 className='m-0 titleCampagin'>Campaign description</h6>
                                        <p className='rightinnerSectionDesc'>
                                            {campaign?.description}
                                        </p>
                                    </div>
                                    <div className='outerSectionCampaign'>
                                        <h6 className='m-0 titleCampagin'>Objectives</h6>
                                        {campaign?.tags?.length > 0 && (
                                            <div className="tags m-0">
                                                {campaign?.tags?.map((tag, index) => (
                                                    <span key={index}>{tag}</span>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        <h6 className='m-0 titleCampagin'>Campaign criteria</h6>
                                        <ul className="criteria-list m-0">
                                            <li className='pt-0'>
                                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clipPath="url(#clip0_13052_5121)">
                                                        <path d="M5.75517 13.2393L0.683167 8.16729C0.610557 8.09487 0.552948 8.00884 0.513641 7.91411C0.474334 7.81939 0.454102 7.71785 0.454102 7.61529C0.454102 7.51274 0.474334 7.41119 0.513641 7.31647C0.552948 7.22175 0.610557 7.13572 0.683167 7.06329L1.78717 5.96075C2.09262 5.65529 2.58571 5.65529 2.88971 5.96075L6.30789 9.37748L13.6228 2.05966C13.9283 1.7542 14.4228 1.7542 14.7268 2.05966L15.8293 3.1622C16.1348 3.46766 16.1348 3.9622 15.8293 4.2662L6.85771 13.2393C6.55371 13.5447 6.05917 13.5447 5.75517 13.2393Z" fill={'var(--primary-color)'} />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_13052_5121">
                                                            <rect width="16" height="16" fill="white" transform="translate(0.453125)" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <span>Location:</span> {campaign?.location || "-"}
                                            </li>
                                            <li>
                                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clipPath="url(#clip0_13052_5121)">
                                                        <path d="M5.75517 13.2393L0.683167 8.16729C0.610557 8.09487 0.552948 8.00884 0.513641 7.91411C0.474334 7.81939 0.454102 7.71785 0.454102 7.61529C0.454102 7.51274 0.474334 7.41119 0.513641 7.31647C0.552948 7.22175 0.610557 7.13572 0.683167 7.06329L1.78717 5.96075C2.09262 5.65529 2.58571 5.65529 2.88971 5.96075L6.30789 9.37748L13.6228 2.05966C13.9283 1.7542 14.4228 1.7542 14.7268 2.05966L15.8293 3.1622C16.1348 3.46766 16.1348 3.9622 15.8293 4.2662L6.85771 13.2393C6.55371 13.5447 6.05917 13.5447 5.75517 13.2393Z" fill={'var(--primary-color)'} />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_13052_5121">
                                                            <rect width="16" height="16" fill="white" transform="translate(0.453125)" />
                                                        </clipPath>
                                                    </defs>
                                                </svg><span>Industry:</span> {campaign?.industry}
                                            </li>
                                            <li><svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_13052_5121)">
                                                    <path d="M5.75517 13.2393L0.683167 8.16729C0.610557 8.09487 0.552948 8.00884 0.513641 7.91411C0.474334 7.81939 0.454102 7.71785 0.454102 7.61529C0.454102 7.51274 0.474334 7.41119 0.513641 7.31647C0.552948 7.22175 0.610557 7.13572 0.683167 7.06329L1.78717 5.96075C2.09262 5.65529 2.58571 5.65529 2.88971 5.96075L6.30789 9.37748L13.6228 2.05966C13.9283 1.7542 14.4228 1.7542 14.7268 2.05966L15.8293 3.1622C16.1348 3.46766 16.1348 3.9622 15.8293 4.2662L6.85771 13.2393C6.55371 13.5447 6.05917 13.5447 5.75517 13.2393Z" fill={'var(--primary-color)'} />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_13052_5121">
                                                        <rect width="16" height="16" fill="white" transform="translate(0.453125)" />
                                                    </clipPath>
                                                </defs>
                                            </svg><span>Targeting:</span> {campaign?.targetting}</li>
                                            <li><svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_13052_5121)">
                                                    <path d="M5.75517 13.2393L0.683167 8.16729C0.610557 8.09487 0.552948 8.00884 0.513641 7.91411C0.474334 7.81939 0.454102 7.71785 0.454102 7.61529C0.454102 7.51274 0.474334 7.41119 0.513641 7.31647C0.552948 7.22175 0.610557 7.13572 0.683167 7.06329L1.78717 5.96075C2.09262 5.65529 2.58571 5.65529 2.88971 5.96075L6.30789 9.37748L13.6228 2.05966C13.9283 1.7542 14.4228 1.7542 14.7268 2.05966L15.8293 3.1622C16.1348 3.46766 16.1348 3.9622 15.8293 4.2662L6.85771 13.2393C6.55371 13.5447 6.05917 13.5447 5.75517 13.2393Z" fill={'var(--primary-color)'} />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_13052_5121">
                                                        <rect width="16" height="16" fill="white" transform="translate(0.453125)" />
                                                    </clipPath>
                                                </defs>
                                            </svg><span>Seniority:</span> {campaign?.seniority}</li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="d-none d-md-block">
                                    <CampaignUpdates campaign={campaign} user={campaign?.creator}
                                        seeMore={seeMore}
                                        remainingUpdates={
                                            (campaignUpdateTotal || 0) -
                                            (campaignUpdateList?.length || 0)
                                        }
                                        campaignUpdateList={campaignUpdateList}
                                        campaignUpdateTotal={campaignUpdateTotal}
                                        setPreviewImages={setPreviewImages}
                                        setPreviewIndex={setPreviewIndex}
                                        setPreviewVisible={setPreviewVisible}
                                        isAdvisorUser={isAdvisorUser}
                                    />
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='caAnalyticsBar'>
                                    <div className='caAnalyticsBarHeader'>
                                        <h3 className='m-0'>Analytics</h3>
                                    </div>
                                    <div className='caAnalyticsHolderOuter'>
                                        <div className='caAnalyticsHolder'>
                                            <div className='caAnalyticsHolderName'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                    <circle cx="6" cy="6" r="6" fill="#BBF7D0" />
                                                    <circle cx="6" cy="6" r="3" fill="#22C55E" />
                                                </svg>
                                                <p>
                                                    Responded to chat
                                                </p>
                                            </div>
                                            <p>
                                                {getTimeAgo(singleCampaignDetail?.campaign?.lastRespondedAt)}
                                            </p>
                                        </div>
                                        <div className='caAnalyticsHolder'>
                                            <div className='caAnalyticsHolderName'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                    <circle cx="6" cy="6" r="6" fill="#FECACA" />
                                                    <circle cx="6" cy="6" r="3" fill="#EF4444" />
                                                </svg>
                                                <p>
                                                    Click through chat
                                                </p>
                                            </div>
                                            <p>
                                                {getTimeAgo(singleCampaignDetail?.campaign?.lastClickThroughAt)}
                                            </p>
                                        </div>
                                        {singleCampaignDetail?.campaign?.pageViewd &&
                                            Object.keys(singleCampaignDetail?.campaign?.pageViewd).length > 0 &&
                                            <div className='caAnalyticsHolder'>
                                                <div className='caAnalyticsHolderName'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                        <circle cx="6" cy="6" r="6" fill="#D6D8FF" />
                                                        <circle cx="6" cy="6" r="3" fill="#494DA2" />
                                                    </svg>
                                                    <p>
                                                        Page viewed
                                                    </p>
                                                </div>
                                                <p>
                                                    {getTimeAgo(singleCampaignDetail?.campaign?.pageViewd?.updatedAt)}
                                                </p>
                                            </div>
                                        }
                                    </div>
                                    {singleCampaignDetail?.campaign?.status === 'launched' &&
                                        <div onClick={sendMessage} className='btnsendView'>
                                            <button className="send-btn">Send message</button>
                                        </div>
                                    }
                                </div>

                                <AdvisorProfile isAdvisorUser={isAdvisorUser} campaign={singleCampaignDetail?.campaign} />
                                <AboutAdvisor isAdvisorUser={isAdvisorUser} campaign={singleCampaignDetail?.campaign} />
                                <VerificationIcons
                                    company={campaign?.company}
                                    isAdvisorUser={isAdvisorUser}
                                    linkedinUrl={linkedinUrl}
                                    creator={campaign?.creator}
                                />
                                <OtherCampaignsAdvisor isAdvisorUser={isAdvisorUser} campaigns={singleCampaignDetail?.latestCampaigns} />

                                {isAdvisorUser && (
                                    <OtherQuotationAdvisor isAdvisorUser={isAdvisorUser} payouts={singleCampaignDetail?.payouts} />
                                )}
                                <div className="d-block d-md-none">
                                    <CampaignUpdates campaign={campaign} user={campaign?.creator}
                                        seeMore={seeMore}
                                        remainingUpdates={
                                            (campaignUpdateTotal || 0) -
                                            (campaignUpdateList?.length || 0)
                                        }
                                        campaignUpdateList={campaignUpdateList}
                                        campaignUpdateTotal={campaignUpdateTotal}
                                        setPreviewImages={setPreviewImages}
                                        setPreviewIndex={setPreviewIndex}
                                        setPreviewVisible={setPreviewVisible}
                                        isAdvisorUser={isAdvisorUser}
                                    />
                                </div>
                            </div>
                            {/* <div className='col-12'>
                                <AboutCompany />
                            </div> */}
                        </div>
                    </div>
                    {previewVisible && (
                        <div className="campaign-preview-modal">

                            {/* Close */}
                            <div
                                className="campaign-preview-close"
                                onClick={() => setPreviewVisible(false)}
                            >
                                ✕
                            </div>

                            {/* Counter */}
                            <div className="campaign-preview-counter">
                                {previewIndex + 1} / {previewImages.length}
                            </div>

                            {/* Images */}
                            <div className="campaign-preview-slider">
                                {previewImages.map((img, i) => (
                                    <img
                                        key={i}
                                        src={
                                            img?.filename
                                                ? backendUrl + img.filename
                                                : "/assets/img/peopleAi.png"
                                        }
                                        alt=""
                                        className={`campaign-preview-image ${i === previewIndex ? "active" : ""
                                            }`}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "/assets/img/peopleAi.png";
                                        }}
                                    />
                                ))}
                            </div>
                            {/* Navigation */}
                            {previewImages.length > 1 && (
                                <>
                                    <button
                                        className="campaign-preview-nav left"
                                        onClick={() =>
                                            setPreviewIndex(prev =>
                                                prev === 0 ? previewImages.length - 1 : prev - 1
                                            )
                                        }
                                    >
                                        ‹
                                    </button>

                                    <button
                                        className="campaign-preview-nav right"
                                        onClick={() =>
                                            setPreviewIndex(prev =>
                                                prev === previewImages.length - 1 ? 0 : prev + 1
                                            )
                                        }
                                    >
                                        ›
                                    </button>
                                </>
                            )}
                        </div>
                    )}
                </>
            }

            <PublicPageFooter />
        </>
    );
};

export default PeopleAi;
